import { Component, Input, inject } from '@angular/core';
import { GuideService } from './guide.service';

/**
 * The Guide button. The shared header bar shows it by itself; an app with a
 * header of its own (Admissions CRM, System Admin) places it there. It hides
 * itself in an app that has not turned the Guide on.
 */
@Component({
    selector: 'spectrum-guide-button',
    template: `
        @if (guide.enabled) {
            <button type="button" class="sgb" [class.sgb--on]="guide.open" [class.sgb--dark]="tone === 'dark'"
                    data-guide="shell-guide" (click)="guide.toggle()"
                    [attr.aria-pressed]="guide.open" title="Guide — help for this screen (press ?)">
                <i class="fas fa-lightbulb"></i>
                <span class="sgb-label">Guide</span>
                @if (guide.tourPending && !guide.open) {
                    <span class="sgb-dot" aria-label="This screen has a tour you haven't taken"></span>
                }
            </button>
        }
    `,
    styles: [`
        :host { display: contents; }
        .sgb {
            position: relative;
            display: inline-flex; align-items: center; gap: 7px;
            height: 38px; padding: 0 14px;
            border-radius: 999px; border: 1px solid #fde68a;
            background: #fffbeb; color: #92400e;
            font: inherit; font-size: 13px; font-weight: 700; white-space: nowrap;
            cursor: pointer; flex-shrink: 0;
            transition: background .15s ease, border-color .15s ease;
        }
        .sgb:hover { background: #fef3c7; border-color: #fcd34d; }
        .sgb--on { background: #fcd34d; border-color: #f59e0b; color: #451a03; }
        .sgb--dark { background: rgba(252, 211, 77, .12); border-color: rgba(252, 211, 77, .35); color: #fcd34d; }
        .sgb--dark:hover { background: rgba(252, 211, 77, .2); }
        .sgb--dark.sgb--on { background: #fcd34d; color: #451a03; }
        .sgb i { font-size: 12.5px; }
        .sgb-dot {
            position: absolute; top: 3px; right: 5px;
            width: 8px; height: 8px; border-radius: 50%;
            background: #4f46e5; box-shadow: 0 0 0 2px #fff;
        }
        @media (max-width: 640px) {
            .sgb { padding: 0 11px; }
            .sgb-label { display: none; }
        }
    `],
})
export class SpectrumGuideButtonComponent {
    readonly guide = inject(GuideService);

    /** `dark` on a dark header. */
    @Input() tone: 'light' | 'dark' = 'light';
}
